import * as React from "react";
import {observer, inject} from "mobx-react";
import ImageGallery from 'react-image-gallery';
import GridBaseEditor from '@components/Grid/GridBaseEditor';

@inject("store")
@observer
export default class IComEditorGroup extends React.Component {
    constructor(props) {
        super(props);

        this.galleryRef = React.createRef();
        this.state = {
            firstClientX: 0,
            firstClientY: 0,
            stopped: false
        }
        this.preventTouch = this.preventTouch.bind(this);
        this.touchStart = this.touchStart.bind(this);

        this.pause = this.pause.bind(this);
        this.stop = this.stop.bind(this);
        this.play = this.play.bind(this);
        this.renderItem = this.renderItem.bind(this);
    }

    pause = function (e) {
        if (this.galleryRef.current) {
            this.galleryRef.current.pause();
        }

    }

    play = function (e) {
        if (!this.state.stopped && this.galleryRef.current) {
            this.galleryRef.current.play();
        }
    }

    stop = function (e) {
        this.pause();
        this.setState({stopped: true});
    }

    preventTouch = function (e) {
        const minValue = 5; // threshold
        let clientX = e.touches[0].clientX - this.state.firstClientX;
        let clientY = e.touches[0].clientY - this.state.firstClientY;

        if (clientX < 0) {
            clientX = clientX * (-1);
        }

        // Vertical scrolling does not work when you start swiping horizontally.
        if (Math.abs(clientX) > minValue) {
            e.preventDefault();
            e.returnValue = false;

            return false;
        }
    }

    touchStart = function (e) {
        this.setState({firstClientX: e.touches[0].clientX, firstClientY: e.touches[0].clientY});
    }


    renderItem(editor) {
        return (<GridBaseEditor {...this.props} control={editor}/>);
    }

    handleCurrentDeviceVisibility(galleryElements) {
        let isMobile = this.props.store.navigation.isMobile;

        let filteredElements = [];

        if (galleryElements && galleryElements.length > 0) {

        } else {
            filteredElements = galleryElements;
        }

        galleryElements.map((item) => {
            if (item.value && item.value.hideOnMobile && !isMobile) {
                filteredElements.push(item);
            } else if (item.value && item.value.hideOnDesktop && isMobile) {
                filteredElements.push(item);
            } else if (item.value && !item.value.hideOnMobile && !item.value.hideOnDesktop) {
                filteredElements.push(item);
            }
        });

        return filteredElements;

    }

    render() {
        const items = this.handleCurrentDeviceVisibility(this.props.model.galleryElements);

        if (items.length > 0) {
            return (
                <div className="editor-group">
                    <ImageGallery ref={this.galleryRef}
                                  items={items}
                                  showFullscreenButton={this.props.showFullscreenButton ? this.props.showFullscreenButton : false}
                                  renderItem={this.renderItem}
                                  showThumbnails={this.props.showThumbnails ? this.props.showThumbnails : false}
                                  infinite={this.props.infinite ? this.props.infinite : true}
                                  showNav={this.props.showNav ? this.props.showNav : false}
                                  showBullets={this.props.showBullets ? this.props.showBullets && items.length > 1 : items.length > 1}
                                  useBrowserFullscreen={false}
                                  showPlayButton={false}
                                  autoPlay={true}
                                  slideInterval={this.props.sliderTimer ? this.props.sliderTimer : 5000}
                                  startIndex={this.props.startIndex ? this.props.startIndex : 0}
                                  onClick={this.pause}
                                  onTouchStart={this.pause}
                                  onMouseOver={this.pause}
                                  onMouseLeave={this.play}
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}